var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg092Undo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29988 14.71C6.48614 14.8947 6.73754 14.9989 6.99988 15C7.26713 14.9989 7.52281 14.8908 7.70988 14.7C8.0976 14.3099 8.0976 13.68 7.70988 13.29L4.35988 9.99997H10.9999C15.4182 9.99997 18.9999 13.5817 18.9999 18V20C18.9999 20.5523 19.4476 21 19.9999 21C20.5522 21 20.9999 20.5523 20.9999 20V18C20.9999 12.4771 16.5227 7.99997 10.9999 7.99997H4.37988L7.69988 4.70997C8.04267 4.31565 8.02411 3.72389 7.65729 3.35183C7.29046 2.97976 6.69903 2.95281 6.29988 3.28997L1.22988 8.28997C1.04057 8.47774 0.934082 8.73333 0.934082 8.99997C0.934082 9.26661 1.04057 9.52221 1.22988 9.70997L6.29988 14.71Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg092Undo);
export default __webpack_public_path__ + "static/media/092-undo.c3c194f60550ebe6ea836118f1ee6d41.svg";
export { ForwardRef as ReactComponent };